/**
 * Rows for the tables that name funds one by one (מנהלים, תשואות, ניתוח סיכון).
 *
 * An admin can switch a fund off ("מוצג ללקוח") — usually an old account, or a
 * second name for a fund that is already listed. Such a fund must not get its
 * own row in front of the client. The /funds list already holds only the funds
 * switched on, so a row stays only when its fund is on that list.
 *
 * Those tables' own total rows follow the rows shown, so each table adds up.
 * The headline figures (שווי כולל, the portfolio return) are NOT built from
 * this — they stay over every fund, as before.
 */
export function onlyVisibleFunds<T extends { fund_id: string }>(
  rows: T[],
  visibleFunds: { fund_id: string }[],
): T[] {
  const visible = new Set(visibleFunds.map((f) => f.fund_id));
  return rows.filter((r) => visible.has(r.fund_id));
}
